import type { FEATURE_TYPES } from 'constants/features';
import type { RootState } from 'reducers/types';

type Features = (typeof FEATURE_TYPES)[number];

export const getFeatures = (state: RootState) => {
  const { features = {} } = state;

  return features;
};

export const getFeature = (state: RootState, feature: Features): boolean => {
  const features = getFeatures(state);

  // biome-ignore lint/suspicious/noPrototypeBuiltins: Object.hasOwn needs Chrome 93+ and this selector runs on every render; our browserslist still includes Chrome 90, where it threw and crashed the payment step (PAAR-7998)
  return Object.prototype.hasOwnProperty.call(features, feature)
    ? !!features[feature]
    : false;
};
